import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'

function formatMoveInDate (dateStr: string): string {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr
	const [year, month, day] = dateStr.split('-').map(Number)
	const date = new Date(year, month - 1, day)
	const formatted = date.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric'
	})
	return formatted.replace(/^(\w+)/, '$1.')
}

interface LeaseTermButtonProps {
	moveInDate: string
	leaseTerm: string
	onEdit?: () => void
	className?: string
}

export function LeaseTermButton ({
	moveInDate,
	leaseTerm,
	onEdit,
	className = ''
}: LeaseTermButtonProps) {
	return (
		<div
			className={`spaces-lease-term spaces:flex spaces:items-center spaces:gap-8 spaces:bg-canvas-4 spaces:pl-16 spaces:pr-8 spaces:py-8 ${className}`}
		>
			<div className='spaces:flex spaces:flex-1 spaces:items-center spaces:gap-12 spaces:text-content-1 spaces:text-16/24 spaces:font-default'>
				<Icon name='Calendar' size={24} className='spaces:text-content-4' />
				{formatMoveInDate(moveInDate)}
				<div className='spaces:w-px spaces:h-24 spaces:bg-canvas-2' />
				{leaseTerm}
			</div>
			{onEdit && (
				<Button
					label='Edit'
					appearance='ghost'
					color='brand'
					size='md'
					aria-label='Edit lease terms'
					spacesClass='spaces-edit-lease'
					onClick={onEdit}
				/>
			)}
		</div>
	)
}
